export default __webpack_public_path__ + "static/media/search.c88b2ffc.png";